import { Province } from '@app/types/province';

/** The years with populated tax rates*/
export type TaxCreditYear = (typeof TAX_CREDIT_DEFAULT_PERSONAL_YEARS)[number];
/** Adding a new year to this array will require rates added to TAX_CREDIT_DEFAULT_PERSONAL_AMOUNTS*/
export const TAX_CREDIT_DEFAULT_PERSONAL_YEARS = [2024, 2025] as const;

/** The default rates sorted by year and jurisdiction*/
export const TAX_CREDIT_DEFAULT_PERSONAL_AMOUNTS: Record<TaxCreditYear, Record<Province | 'Canada', number>> = {
    2024: {
        Canada: 15705,
        AB: 21885,
        BC: 12580,
        MB: 15780,
        NB: 13044,
        NL: 10818,
        NT: 17373,
        NS: 11481,
        NU: 18767,
        ON: 12399,
        PE: 13500,
        QC: 18056,
        SK: 18491,
        YT: 15705,
    },
    2025: {
        Canada: 16129,
        AB: 22323,
        BC: 12932,
        MB: 15969,
        NB: 13396,
        NL: 11067,
        NT: 17842,
        NS: 11744,
        NU: 19274,
        ON: 12747,
        PE: 14250,
        QC: 18571,
        SK: 18991,
        YT: 16129,
    },
};
